import StatsMapController from "../stimulus_controllers_standalone/stats_map_controller"

window.Stimulus.register("stats-map", StatsMapController)
